module.exports = __webpack_public_path__ + "static/media/data.4e902e44.svg";